/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_profile_roadmaps_empty_usercreated1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자가 생성한 로드맵이 없습니다`)
};

const en_profile_roadmaps_empty_usercreated1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User has no created roadmaps`)
};

const ja_profile_roadmaps_empty_usercreated1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーが作成したロードマップはありません`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const profile_roadmaps_empty_usercreated1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profile_roadmaps_empty_usercreated1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profile_roadmaps_empty_usercreated1", locale)
	if (locale === "ko") return ko_profile_roadmaps_empty_usercreated1(inputs)
	if (locale === "en") return en_profile_roadmaps_empty_usercreated1(inputs)
	return ja_profile_roadmaps_empty_usercreated1(inputs)
};
export { profile_roadmaps_empty_usercreated1 as "profile_roadmaps_empty_userCreated" }